import { Box, styled } from '@mui/material'

export const Wrapper = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.blue1};
  background-color: ${({ theme }) => theme.palette.custom.gray4};
  border-left: 1px solid ${({ theme }) => theme.palette.custom.white};

  &:hover {
    background-color: ${({ theme }) => theme.palette.custom.gray6};
  }
`

export const Statistic = styled(Box)`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: ${({ theme }) => theme.palette.custom.green1};
  margin-top: 3px;

  &.negative {
    color: ${({ theme }) => theme.palette.custom.red1};
  }
`

export const ArrowIconWrapper = styled(Box)`
  color: inherit;
  margin-right: 2px;

  .negative & {
    transform: rotate(180deg);
    margin-bottom: 3px;
  }
`
